export const COUNTERPART_ICONS = {
    software: "ri-apps-2-line",
    hardware: "ri-server-line",
    website: "ri-global-line",
    mailbox: "ri-mail-line",
    external_system: "ri-links-line",
    database: "ri-database-2-line",
    file_storage: "ri-folder-line",
    other: "ri-shape-line",
};

const ASSET_TYPE_LABELS = {
    software: "Software",
    hardware: "Hardware",
    other: "Other",
};

export const isCurrentAsset = (side, currentAssetId) => {
    if (!side || side.kind !== "asset" || currentAssetId == null) {
        return false;
    }

    return Number(side.id) === Number(currentAssetId);
};

export const getCounterpart = (flow, direction, currentAssetId) => {
    if (currentAssetId != null) {
        if (isCurrentAsset(flow?.destination, currentAssetId)) {
            return flow.source;
        }

        if (isCurrentAsset(flow?.source, currentAssetId)) {
            return flow.destination;
        }
    }

    return direction === "receives" ? flow?.source : flow?.destination;
};

export const inferWrapperAssetIdFromFlows = (groups = {}) => {
    const receives = groups.receives_from || [];
    const sends = groups.sends_to || [];
    const relations = groups.relations || [];

    for (const flow of receives) {
        if (flow?.destination?.kind === "asset" && flow.destination.id != null) {
            return Number(flow.destination.id);
        }
    }

    for (const flow of sends) {
        if (flow?.source?.kind === "asset" && flow.source.id != null) {
            return Number(flow.source.id);
        }
    }

    for (const flow of relations) {
        if (flow?.source?.kind === "asset" && flow.source.type === "software") {
            return Number(flow.source.id);
        }

        if (
            flow?.destination?.kind === "asset" &&
            flow.destination.type === "software"
        ) {
            return Number(flow.destination.id);
        }
    }

    return null;
};

export const mergeRelationFlows = (
    receivesFrom = [],
    sendsTo = [],
    relations = [],
    currentAssetId
) => {
    const incoming = [...receivesFrom];
    const outgoing = [...sendsTo];

    relations.forEach((flow) => {
        if (isCurrentAsset(flow.destination, currentAssetId)) {
            incoming.push(flow);
            return;
        }

        if (isCurrentAsset(flow.source, currentAssetId)) {
            outgoing.push(flow);
            return;
        }

        const destinationIsHardware = flow.destination?.type === "hardware";
        const sourceIsHardware = flow.source?.type === "hardware";

        if (destinationIsHardware && !sourceIsHardware) {
            outgoing.push(flow);
            return;
        }

        if (sourceIsHardware && !destinationIsHardware) {
            incoming.push(flow);
            return;
        }

        outgoing.push(flow);
    });

    return { incoming, outgoing };
};

export const buildOptionLabelMap = (options = []) => {
    return (options || []).reduce((map, option) => {
        if (option?.value) {
            map[option.value] = option.label || option.value;
        }

        return map;
    }, {});
};

export const getCounterpartTypeLabel = (counterpart, endpointTypeLabels, t) => {
    if (!counterpart) {
        return "";
    }

    if (counterpart.kind === "asset") {
        return t(ASSET_TYPE_LABELS[counterpart.type] || counterpart.type);
    }

    return t(endpointTypeLabels[counterpart.type] || counterpart.type);
};

export const getCounterpartIcon = (counterpart) => {
    return COUNTERPART_ICONS[counterpart?.type] || COUNTERPART_ICONS.other;
};

const COLLAPSED_ITEM_LIMIT = 3;

export const getCollapsedItems = (items = [], limit = COLLAPSED_ITEM_LIMIT) => {
    const list = Array.isArray(items) ? items : [];
    const visible = list.slice(0, limit);
    const overflow = Math.max(0, list.length - visible.length);

    return { visible, overflow };
};

export const toFlowCard = (flow, direction, currentAssetId) => {
    return {
        id: flow.id,
        direction,
        counterpart: getCounterpart(flow, direction, currentAssetId),
        purpose: flow.purpose || "",
        notes: flow.notes || "",
        dataTypes: flow.data_types || [],
        dataCategories: flow.data_categories || [],
        methods: flow.methods || [],
        relation: flow.relation || null,
    };
};
